import { render, staticRenderFns } from "./Availity.vue?vue&type=template&id=836ef06a&scoped=true"
import script from "./Availity.vue?vue&type=script&lang=js"
export * from "./Availity.vue?vue&type=script&lang=js"
import style0 from "./Availity.vue?vue&type=style&index=0&id=836ef06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836ef06a",
  null
  
)

export default component.exports